import { useState, useEffect } from 'react';

export function useWindowSize() {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  useEffect(() => {
    // Fungsi untuk update state saat layar di-resize
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    
    // Bersihkan listener saat komponen tidak lagi digunakan (unmount)
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
}